export function productSlider() {
    const $window = $(window);
    let $slides = $(".product-slider .slides");
    let isDesktopWidth = $window.outerWidth() > 1200;
    let dotRadius = isDesktopWidth ? 13 : 10;

    if (isDesktopWidth) {
        desktopView($slides);
    }

    $window.on("load", () => {
        init();
    });

    window.addEventListener("resize", () => {
        setTimeout(() => {
            isDesktopWidth = $window.outerWidth() > 1200;
            dotRadius = isDesktopWidth ? 13 : 10;
        }, 500);
    });

    function desktopView($slides) {
        let coef = 3;
        let $slideItems = $slides.find(".slide");
        let totalSlides = $slideItems.length;
        let detached = $slideItems.detach();
        let totalSlidesInLastDesktopSlide = totalSlides - parseInt(totalSlides / coef) * coef;

        for (let i = 0; i < totalSlides; i += coef) {
            let desktopSlide = document.createElement("div");
            desktopSlide.classList.add("desktop-slide");

            for (let j = i; j < i + 3 && j < totalSlides; j++) {
                desktopSlide.appendChild(detached[j]);
            }

            $slides.append(desktopSlide);
        }

        switch (totalSlidesInLastDesktopSlide) {
        case 1:
            $slides.find(".desktop-slide:last-child").addClass("single-slide");
            break;
        case 2:
            $slides.find(".desktop-slide:last-child").addClass("dual-slide");
            break;
        default:
            break;
        }
    }

    function init() {
        [...$slides].forEach(holder => {
            const $holder = $(holder);
            let $sliderHolder = $holder.parent(".product-slider");
            let slickSettings = setSlickSliderSettings($sliderHolder);
            let count = 0;
            let switched = false;

            // Slider Events
            $holder.on("init", (event, slick, direction) => {
                count = slick.slideCount;
            });

            $holder.on("init reInit afterChange", (event, slick, currentSlide, nextSlide) => {
                let activeDot = $sliderHolder.find(".slick-active .dot").get(0);
                switched = false;
                if (count === 1) {
                    $sliderHolder.find("ul.slick-dots").remove();
                }
                startAnimation(activeDot, 5000);
            });

            $holder.on("beforeChange", (event, slick, currentSlide, nextSlide) => {
                switched = true;
            });

            $holder.slick(slickSettings);

            function startAnimation(element, speed) {
                function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
                    var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;

                    return {
                        x: centerX + (radius * Math.cos(angleInRadians)),
                        y: centerY + (radius * Math.sin(angleInRadians))
                    };
                }

                function describeArc(x, y, radius, startAngle, endAngle) {
                    var start = polarToCartesian(x, y, radius, endAngle);
                    var end = polarToCartesian(x, y, radius, startAngle);

                    var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

                    var d = [
                        "M", start.x, start.y,
                        "A", radius, radius, 0, largeArcFlag, 0, end.x, end.y
                    ].join(" ");
                    return d;
                }

                let period = speed;
                let step = Math.floor(period / 360);

                let start = +new Date();
                let finish = start + period;

                let i = 0;
                let newTime = +new Date();
                let prevTime = start;

                function animate() {
                    newTime = +new Date();
                    i = Math.floor((newTime - start) / step);
                    if (i > 360 || switched === true) i = 0;
                    element.setAttribute("d", describeArc(dotRadius, dotRadius, dotRadius, 0, i));
                    prevTime += step * i;
                    if (newTime < finish && switched === false) {
                        window.requestAnimationFrame(animate);
                    } else {
                        element.setAttribute("d", "");
                        switched = false;
                    }
                }

                window.requestAnimationFrame(animate);
            }
        });
    }

    function setSlickSliderSettings($sliderHolder) {
        return {
            mobileFirst: true,
            autoplay: true,
            infinite: true,
            speed: 500,
            autoplaySpeed: 4700,
            dots: true,
            flipDropToFit: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
            arrows: false,
            pauseOnHover: true,
            customPaging: (slider, i) => {
                return "<span><svg><path class=\"dot\" fill=\"none\" stroke=\"#000\" stroke-width=\"2\" /></svg></span>";
            }
        };
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/productSlider.js